module.exports = {
      id: "x-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#x-usage",
      toString: function () {
        return this.url;
      }
    }